<ion-item *ngIf="stringSearch" class="compact fullWidth" lines="none">
    <ion-icon slot="start" name="search"></ion-icon>
    <ion-item lines="none" class="compact fullWidth">
        <ion-label *ngIf="stringSearch.search" class="compactlabel" position="stacked">
            {{translationPrefix + '.name' | translate}}
        </ion-label>
        <ion-input class="compact" minlength=2 debounce=250
                   placeholder="{{translationPrefix +'.all' | translate}}"
                   [(ngModel)]="stringSearch.search" (ionChange)="dataChange()" (ionInput)="dataChange()"
                   (ionBlur)="dataChange()">
        </ion-input>
        <ion-icon *ngIf="stringSearch.search" slot="end" name="close"
                  (click)="clearSearch()">
        </ion-icon>
    </ion-item>
    <ion-item button *ngIf="stringSearch.search" lines="none" slot="end" class="compact right" detail="false">
        <ion-label position="stacked" class="compactlabel preLineWhitespace">
            {{translationPrefix + '.exact' | translate}}
        </ion-label>
        <ion-checkbox class="compact"
                      [(ngModel)]="stringSearch.exact" (ionChange)="dataChange()">
        </ion-checkbox>
    </ion-item>
</ion-item>
